import { useSelector } from "react-redux";

import { DeleteOutline } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { getFilterTypeById } from "slices/books/booksSelectors";

import { SearchSettingsKeyEnum } from "./SearchSettings";
import styles from "./SearchSettings.module.css";
import { SearchSettingsSelect } from "./SearchSettingsSelect";
import { SearchSettingsTextField } from "./SearchSettingsTextField";

export const SearchSettingsCondition = ({
	condition: { id, operation: operationId, value },
	setValue,
	conditionOptions,
	columnName,
	showDeleteButton,
}) => {
	const filterTypeById = useSelector(getFilterTypeById);
	const filterType = filterTypeById[operationId];

	const disabledValueField = ["Пустое значение", "Не пустое значение"].includes(filterType.name);

	return (
		<div className={styles.conditionContainer}>
			<SearchSettingsSelect
				value={filterType}
				setValue={(newValue) =>
					setValue((prev) =>
						prev.map((clmSet) => {
							if (clmSet[SearchSettingsKeyEnum.FIELD] === columnName) {
								return {
									...clmSet,
									[SearchSettingsKeyEnum.FILTERS]: clmSet[SearchSettingsKeyEnum.FILTERS].map((condition) => {
										if (condition.id === id) {
											return {
												...condition,
												operation: newValue.id,
											};
										}
										return condition;
									}),
								};
							}
							return clmSet;
						})
					)
				}
				options={conditionOptions}
			/>
			<div className={styles.conditionValue}>
				<SearchSettingsTextField
					value={value}
					setValue={(newValue) =>
						setValue((prev) =>
							prev.map((clmSet) => {
								if (clmSet[SearchSettingsKeyEnum.FIELD] === columnName) {
									return {
										...clmSet,
										[SearchSettingsKeyEnum.FILTERS]: clmSet[SearchSettingsKeyEnum.FILTERS].map((condition) => {
											if (condition.id === id) {
												return {
													...condition,
													value: newValue,
												};
											}
											return condition;
										}),
									};
								}
								return clmSet;
							})
						)
					}
					disabled={disabledValueField}
					sx={{
						marginRight: showDeleteButton ? "3px" : "0px",
						"& .MuiOutlinedInput-root": {
							paddingRight: "2px",
						},
					}}
				/>
				{showDeleteButton && (
					<IconButton
						size="small"
						sx={{ padding: 0 }}
						onClick={() =>
							setValue((prev) =>
								prev.map((clmSet) => {
									if (clmSet[SearchSettingsKeyEnum.FIELD] === columnName) {
										return {
											...clmSet,
											[SearchSettingsKeyEnum.FILTERS]: clmSet[SearchSettingsKeyEnum.FILTERS].filter(
												(condition) => condition.id !== id
											),
										};
									}
									return clmSet;
								})
							)
						}
					>
						<DeleteOutline sx={{ fontSize: "16px" }} />
					</IconButton>
				)}
			</div>
		</div>
	);
};
